<script>
  /**
   *  getRoom.svelte
   * ------------------------------------------------------------------
   * Renders only when no valid room is specified in URL.
   *
   */

  import { onMount, createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';
  import { ui } from '../stores';
  import rooms from '../rooms';

  export let room = null;

  let roomField, invalidRoom;

  const dispatch = createEventDispatcher();

  function handleSubmit(e) {
    e.preventDefault();
    invalidRoom = !validateRoom(roomField);
    if (!invalidRoom) {
      // window.location = `/${roomField}`;
      room = roomField;
      window.history.pushState('', '', `/${room}`);
      ui.setTheme(room);
    }
  }

  function validateRoom(room) {
    return room in rooms;
  }

  onMount(() => {
    if (room) {
      invalidRoom = !validateRoom(roomField);
    }
  });
</script>

<!-- Room Form -->
<div class="w-full max-w-xs mx-auto" style="margin-top:40vh" transition:fade>
  <form
    class="shadow-md rounded-lg px-8 pt-6 pb-8 mb-4"
    style="background:#325280"
    on:submit="{handleSubmit}">
    <!-- Room name input -->
    <div class="mb-4">
      <label class="block text-white text-sm font-bold mb-1" for="key">Enter room name</label>
      <input
        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight
        focus:outline-none focus:shadow-outline"
        id="key"
        type="text"
        spellcheck="false"
        bind:value="{roomField}" />
    </div>

    <!-- Validation failed -->
    {#if invalidRoom}
      <h2 class="text-red-600 font-bold my-4">Please enter a valid room name.</h2>
    {/if}

    <!-- Submit button -->
    <div class="flex items-center justify-between">
      <button
        class="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        style="background:#4C6993"
        type="submit">
        Enter
      </button>
    </div>
  </form>
  <p class="text-center text-gray-500 text-xs">
    &copy; 2020 MingleSpace, Inc. All rights reserved.
  </p>
</div>
